/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Street/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import AutocompleteAddress from 'DesignSystem/AutocompleteAddress/index'
import React from 'react'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'



/** @type {import('Simple/types.js').View} */
export default function Street({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/AddressInput/Street",
  onChange,
  onChooseAddress,
  selected
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let questionAnswerStreetIdValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'answer.street.id',
})
let questionAnswerStreetValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'answer.street',
})
let questionAnswerStreetChangeData = fromData.useDataChange({ viewPath,
context: 'question',
path: 'answer.street',
})
let dtTypographyFontsizeMm = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.mm'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaInputContent
  viewPath={`${viewPath}/TysiaInputContent`}
 paddingLeft={dtSpaceXxs}
 maxWidth={400}
>
{childProps => (
<AutocompleteAddress
{...childProps}
  viewPath={`${viewPath}/AutocompleteAddress`}
 fontSize={dtTypographyFontsizeMm}
 marginTop={dtSpaceXxs}
 marginRight={0}
 paddingBottom={dtSpaceS}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
 paddingTop={dtSpaceS}
 data="question.answer.street.id"
 id={questionAnswerStreetIdValueData}
 key={questionAnswerStreetIdValueData}
 data="question.answer.street"
 value={questionAnswerStreetValueData}
 onChange={questionAnswerStreetChangeData}
 onChooseAddress={onChooseAddress}
 selected={selected}
/>
)}
</TysiaInputContent>
{children}
</React.Fragment>)
}